import { useActivitySummaryContext } from '@user/features/Activity/ActivitySummary/context'
import { useState } from 'react'

export function useData() {
  const [
    {
      tableState: { loading },
    },
  ] = useActivitySummaryContext()

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const open = Boolean(anchorEl)

  return {
    open,
    anchorEl,
    setAnchorEl,
    disabled: loading,
  }
}
